(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-cuenta-atras"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__sCuentaAtrasToggle) return;
    window.__sCuentaAtrasToggle = true;

    const setOpen = (toggle, panel, open) => {
      toggle.setAttribute('aria-expanded', String(open));
      panel.classList.toggle('is-open', open);
      panel.toggleAttribute('inert', !open);
      if (open) {
        panel.removeAttribute('aria-hidden');
      } else {
        panel.setAttribute('aria-hidden', 'true');
      }
    };

    // Delegado en document: sigue funcionando aunque el editor re-renderice la sección.
    document.addEventListener('click', (event) => {
      const toggle = event.target instanceof Element ? event.target.closest('[data-cuenta-atras-toggle]') : null;
      if (!toggle) return;

      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;

      const open = toggle.getAttribute('aria-expanded') !== 'true';
      setOpen(toggle, panel, open);

      if (open) {
        // Esperar a que termine la animación y llevar el foco al email.
        window.setTimeout(() => {
          panel.querySelector('input[type="email"]')?.focus({ preventScroll: true });
        }, 360);
      }
    });

    // Escape cierra el formulario y devuelve el foco al botón.
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const panel = event.target instanceof Element ? event.target.closest('.s-cuenta-atras__form.is-open') : null;
      if (!panel) return;
      const toggle = document.querySelector(`[aria-controls="${panel.id}"]`);
      if (!toggle) return;
      setOpen(toggle, panel, false);
      toggle.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
